import React from 'react';
import { Redirect } from 'expo-router';
import type { Href } from 'expo-router';
import { ActivityIndicator, View } from 'react-native';

import McsPreparationScreen from '../../src/screens/mcs/McsPreparationScreen';
import { useAuth } from '../../src/context/AuthContext';
import { pathForPhase } from '../../src/navigation/phaseRedirect';
import { MCS_ENABLED } from '../../src/config/featureFlags';
import { ROUTES } from '../../src/navigation/routes';
import { hasEntitlement } from '../../src/utils/billingAccess';
import { MentorPlanLock } from '../../src/components/mentorEngagements/MentorPlanLock';

export default function McsPreparationRoute() {
  const { phase, billingStatus } = useAuth();

  if (!MCS_ENABLED) {
    return <Redirect href={ROUTES.MENTOR_ENGAGEMENTS as Href} />;
  }

  if (phase === 'loading') {
    return (
      <View style={{ flex: 1, alignItems: 'center', justifyContent: 'center', backgroundColor: '#f7f5f1' }}>
        <ActivityIndicator size="large" color="#3147b7" />
      </View>
    );
  }
  if (phase !== 'authenticated') {
    return <Redirect href={pathForPhase(phase) as Href} />;
  }

  // Server-denied (e.g. lapsed tier3 with credits, D3): lock in place.
  if (!hasEntitlement(billingStatus, 'mcs_prep', true)) {
    return <MentorPlanLock surface="mcs-preparation" />;
  }

  return <McsPreparationScreen />;
}
